var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3573 5.08655L20.3093 10.6665H13.688L14.6427 5.57988L12.024 5.08655L10.976 10.6665H5.33333V13.3332H10.476L9.47467 18.6665H4V21.3332H8.97467L8.02267 26.4065L10.6427 26.8985L11.688 21.3332H18.3093L17.3573 26.4065L19.9773 26.8985L21.0213 21.3332H26.6667V18.6665H21.5213L22.5227 13.3332H28V10.6665H23.0227L23.9773 5.57988L21.3573 5.08655ZM18.808 18.6665H12.188L13.1893 13.3332H19.8107L18.808 18.6665Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.346134e6202ab4a27744d984a04e1393.svg";
export { ForwardRef as ReactComponent };